import { Button } from '../../components/ui/Button';

export const StaffList = () => {
  return (
    <div className="p-6">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-3xl font-bold">Staff</h1>
        <Button>Add Staff</Button>
      </div>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-gray-500">Staff list</p>
      </div>
    </div>
  );
};
